function _slicedToArray(r, e) {
  return (
    _arrayWithHoles(r) ||
    _iterableToArrayLimit(r, e) ||
    _unsupportedIterableToArray(r, e) ||
    _nonIterableRest()
  );
}
function _nonIterableRest() {
  throw new TypeError(
    "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
  );
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return (
      "Object" === t && r.constructor && (t = r.constructor.name),
      "Map" === t || "Set" === t
        ? Array.from(r)
        : "Arguments" === t ||
          /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)
          ? _arrayLikeToArray(r, a)
          : void 0
    );
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t =
    null == r
      ? null
      : ("undefined" != typeof Symbol && r[Symbol.iterator]) || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (((i = (t = t.call(r)).next), 0 === l)) {
        if (Object(t) !== t) return;
        f = !1;
      } else
        for (
          ;
          !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l);
          f = !0
        );
    } catch (r) {
      ((o = !0), (n = r));
    } finally {
      try {
        if (!f && null != t.return && ((u = t.return()), Object(u) !== u))
          return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
define("SuiteDB.SDBOtherCharges.SDBOtherCharges", [
  "SuiteDB.SDBOtherCharges.SDBOtherCharges.View",
  "SuiteDB.SDBOtherCharges.SDBOtherCharges.Model",
], function (SDBOtherChargesView, SDBOtherChargesModel) {
  "use strict";

  return {
    mountToApp: function mountToApp(container) {
      var env = container.getComponent("Environment");
      var config = env.getConfig("OtherCharges");
      var model = SDBOtherChargesModel.getInstance();

      var chargeItemIds = [];
      var states = [];
      var types = [];

      if (!config || !config.length) return;
      for (var i = 0; i < config.length; i++) {
        chargeItemIds.push(config[i].itemid);
        states.push(config[i].state);
        types.push(config[i].type);
      }

      model
        .fetch({
          data: {
            chargeItems: JSON.stringify(chargeItemIds),
            states: JSON.stringify(states),
          },
          async: true,
        })
        .done(function (res) {
          var info = res;
          if (info.status != "Fail") {
            var chargeItems = info;
            var keys = Object.keys(chargeItems);
            var index = 0;
            for (var _i = 0; _i < keys.length; _i++) {
              var key = keys[_i];
              var value = chargeItems[key];
              for (var i = 0; i < chargeItems[key].length; i++) {
                chargeItems[key][i].type = types[index];
                index++;
              }
            }
            model.set("chargeItems", chargeItems);
          }
        });

      //render view after fetching
      model.on("change:chargeItems", function () {
        var currentView = model.get("currentView");
        if (!currentView) return;
        currentView.selectChargeItem();
        currentView.render();
      });

      /** @type {LayoutComponent} */
      var layout = container.getComponent("Layout");

      if (layout) {
        layout.addChildView("SDBOtherChargesView", function () {
          return new SDBOtherChargesView({ container: container });
        });
      }
    },
  };
});
